import type { UseQueryOptions } from "@tanstack/react-query";

import { useApiQuery } from "@/hooks/api/use-api-query";
import type { ApiError } from "@/lib/api-client";
import type { OrganizationSummary } from "./use-organizations-query";

export type OrganizationResponse = {
	organization: OrganizationSummary;
};

type UseOrganizationByIdOptions = Omit<
	UseQueryOptions<OrganizationResponse, ApiError>,
	"queryKey" | "queryFn"
>;

export function useOrganizationById(
	organizationId?: string,
	options?: UseOrganizationByIdOptions,
) {
	const query = useApiQuery<OrganizationResponse, ApiError>({
		queryKey: ["organization", organizationId],
		path: organizationId ? `/api/organizations/${organizationId}` : "",
		queryOptions: {
			...options,
			enabled: Boolean(organizationId) && (options?.enabled ?? true),
		},
	});

	return {
		...query,
		organization: query.data?.organization ?? null,
	};
}
